import DisputesMergeService from '../services/disputes-merge-service';

export const disputesMerge = {
    namespaced: true,
    state: {
        masterDispute: null,
        childDisputes: [],
    },
    actions: {
        initMasterDispute({ commit }, masterDispute) {
            commit('setMasterDispute', masterDispute);
        },
        getMasterDisputeByReference({ commit }, disputeReference) {
            commit('setIsBusy', true, { root: true });
            commit('setMasterDispute', null);
            return DisputesMergeService.getDisputeByReference(disputeReference)
                .then((result) => {
                    commit('setIsBusy', false, { root: true });
                    commit('setMasterDispute', result.model);
                    return Promise.resolve(result.model);
                })
                .catch((error) => {
                    commit('setIsBusy', false, { root: true });
                    return Promise.reject(error);
                })
        },
        getChildDisputeByReference({ commit }, disputeReference) {
            commit('setIsBusy', true, { root: true });
            return DisputesMergeService.getDisputeByReference(disputeReference)
                .then((result) => {
                    commit('setIsBusy', false, { root: true });
                    commit('addChildDisputes', result.model);
                    return Promise.resolve(result.model);
                })
                .catch((error) => {
                    commit('setIsBusy', false, { root: true });
                    return Promise.reject(error);
                })
        },
        mergeDisputes({ commit, dispatch }, payload) {
            commit('setIsBusy', true, { root: true });
            return DisputesMergeService.mergeDisputes(payload)
                .then(async (result) => {
                    const disputeSearchPayload = {
                        pageParameters:{"size":10,"number":0},
                        sort:{"item":"updatedAt","direction":"descending"},
                        fieldNames:[],
                        searchTerm: null,
                        operator: 1,
                        yearFilter: null,
                        type: "standard"
                    }
                    await new Promise(resolve => setTimeout(resolve, 3000));
                    const response = await dispatch('disputeSearch/searchDispute', disputeSearchPayload, { root: true })
                    commit('disputeSearch/setDisputeSearchResult', response);
                    commit('setIsBusy', false, { root: true });
                    commit('resetMergeInputs');
                    return Promise.resolve(result.model);
                })
                .catch((error) => {
                    commit('setIsBusy', false, { root: true });
                    return Promise.reject(error);
                });
        },
    },

    mutations: {
        setMasterDispute(state, newState) {
            state.masterDispute = newState;
        },
        addChildDisputes(state, newState) {
            const existingChildDispute = state.childDisputes.find(d => d.disputeId === newState.disputeId);
            if (!existingChildDispute) {
                state.childDisputes.push(newState);
            }
        },
        resetMergeInputs(state) {
            state.masterDispute = null;
            state.childDisputes = [];
        }
    },
};
